import React,{useEffect,useState} from 'react';
import {AnimatePresence,motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SectionIntro from './SectionIntro';
import {faqs} from '../data/content';

const {FiPlus,FiPhone,FiMail,FiMapPin,FiFacebook,FiInstagram}=FiIcons;

function FAQ() {
  const [open,setOpen]=useState(0);

  return (
    <section className="section faq" id="faq">
      <div className="container faq-layout">
        <SectionIntro eyebrow="Common Questions" title="Everything You Need to Know" />
        <div className="accordion">
          {faqs.map((faq,index)=> (
            <article className={open===index ? 'open' : ''} key={faq.question}>
              <button
                type="button"
                onClick={()=> setOpen(open===index ? -1 : index)}
                aria-expanded={open===index}
              >
                <span>{faq.question}</span>
                <motion.span animate={{rotate: open===index ? 45 : 0}}>
                  <SafeIcon icon={FiPlus} />
                </motion.span>
              </button>
              <AnimatePresence initial={false}>
                {open===index && (
                  <motion.div
                    className="answer"
                    initial={{height: 0,opacity: 0}}
                    animate={{height: 'auto',opacity: 1}}
                    exit={{height: 0,opacity: 0}}
                    transition={{duration: 0.35,ease: [0.22,1,0.36,1]}}
                  >
                    <p>{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function Contact() {
  useEffect(()=> {
    const script=document.createElement('script');
    script.src='https://formrobin.com/js/embed.js';
    script.async=true;
    document.body.appendChild(script);

    return ()=> {
      document.body.removeChild(script);
    };
  },[]);

  return (
    <section className="section contact" id="contact">
      <div className="container contact-layout">
        <div className="contact-copy">
          <span className="eyebrow">Start Your Project</span>
          <h2>Let's Make Your Space Look Incredible</h2>
          <p>
            Get a free,no-pressure estimate — most homeowners hear back from us
            within 24 hours.
          </p>
          <div className="contact-list">
            <a href="tel:+15126792228">
              <SafeIcon icon={FiPhone} />
              <span>
                <small>Call or text</small>
                512-679-2228
              </span>
            </a>
            <a href="mailto:windycitypaintersinc@gmail.com">
              <SafeIcon icon={FiMail} />
              <span>
                <small>Email</small>
                windycitypaintersinc@gmail.com
              </span>
            </a>
            <div>
              <SafeIcon icon={FiMapPin} />
              <span>
                <small>Service area</small>
                Austin,TX & surrounding areas
              </span>
            </div>
          </div>
          <div className="social-links">
            <a href="https://www.facebook.com/" aria-label="Facebook">
              <SafeIcon icon={FiFacebook} />
            </a>
            <a href="https://www.instagram.com/" aria-label="Instagram">
              <SafeIcon icon={FiInstagram} />
            </a>
          </div>
        </div>

        <motion.div
          className="contact-form"
          initial={{opacity: 0,y: 35}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
        >
          <div className="formrobin-embed" data-path="/f/jr8gk73"></div>
        </motion.div>
      </div>
    </section>
  );
}

export {FAQ,Contact};